module.exports = __webpack_public_path__ + "img/58.6a48427d.jpg";